import * as React from 'react';

const getVariable = require('../services/variablesConfig');

const linkAreaCliente = getVariable('linkAreaCliente');

function ModalVideoUnavailable({ handleModalVideoUnavailable }) {
    return (
        <div id="modalVideoUnavailable" className="bundleTela bundleBackgroundPopup" style={{ "marginTop": "50px" }}>
            <div className="bundleBox2">
                <label className="bundleTitulo bundleCentro">
                    Vídeo indisponível
                </label>
                <span id="linkCloseModalVideoUnavailable" className="close" onClick={() => handleModalVideoUnavailable(false)}>&times;</span>
                <label className="bundleLabelPopup1">
                    <p>O vídeo fica disponível por tempo determinado, por segurança. <br />
                        Para acessar as informações da sua proteção, acesse a&nbsp;
                        <a href={linkAreaCliente} target="_blank" rel="noopener noreferrer">Área do Cliente</a>.</p>
                </label>
            </div>
        </div >
    );
}

export default ModalVideoUnavailable;